
import { createContext, useReducer } from "react";
import VoyageReducer from "./VoyageReducer";

const INITIAL_STATE = {
    voyages: [],
    count: 1,
    isFetching: false,
    error: false,
    voyage: {},
    isFetchingAdd: false,
    errorAdd: false,
    voyageUpdate: {},
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingGet: false,
    errorGet: false,
};


export const VoyageContext = createContext(INITIAL_STATE);

export const VoyageContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(VoyageReducer, INITIAL_STATE);
    
    return (
      <VoyageContext.Provider
        value={{
          voyages: state.voyages,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          voyage: state.voyage,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          voyageUpdate: state.voyageUpdate,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          dispatch,
        }}
      >
        {children}
      </VoyageContext.Provider>
    );
  };